module.exports = __webpack_public_path__ + "static/work_Cryptonow_SocialPost-7481203f3ff608bd6c30208bfb70ef10.mp4";